export default __webpack_public_path__ + "static/media/doduae.dacff909.png";